





































import vue, {PropType} from 'vue';
import {Editor} from '@tiptap/vue-2';
import {Mark} from 'prosemirror-model';

interface ComponentData {
  dialogDisplayed: boolean;
  isUpdate: boolean;
  link: string;
}

export default vue.extend({
  name: 'AddLink',

  props: {
    editor: {
      required: false,
      type: Object as PropType<Editor | null>,
    },
  },

  data: (): ComponentData => ({
    dialogDisplayed: false,
    isUpdate: false,
    link: '',
  }),

  computed: {
    links(): number | undefined {
      if (this.editor === null) return;
      if ((this.editor as Editor).isActive('link')) return 0;

      return;
    },
    linkIsEmpty(): boolean {
      return !this.link;
    },
  },

  methods: {
    onAddLink() {
      if (this.link) {
        (this.editor as Editor)
            .chain()
            .focus()
            .extendMarkRange('link')
            .setLink({href: this.link})
            .run();

        this.link = '';
      } else {
        (this.editor as Editor)
            .chain()
            .focus()
            .extendMarkRange('link')
            .unsetLink()
            .run();
      }

      this.dialogDisplayed = false;
    },
    onTest() {
      const state = (this.editor as Editor).state;

      // get marks, if any from selected area
      const {from, to} = state.selection;
      let marks: Mark[] = [];
      state.doc.nodesBetween(from, to, (node) => {
        marks = [...marks, ...node.marks];
      });

      this.link = marks.find((markItem) => markItem.type.name === 'link')?.attrs.href || '';
      this.isUpdate = !!this.link
    },
  },
});
